import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { BOOTH_PATH_NAME } from './booth.constants';
import {
  BoothApplicationResetResponseSchema,
  BoothApplicationScopedMutationInputSchema,
  BoothEnsureSignalSeedsResponseSchema,
} from './booth.schema';

export const BoothContract = terraContract
  .prefix(`/${BOOTH_PATH_NAME}`)
  .router({
    resetApplication: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/applications/{applicationId}/reset',
        summary: 'Reset booth application state for the next player',
        inputStructure: 'detailed',
      })
      .input(BoothApplicationScopedMutationInputSchema)
      .output(BoothApplicationResetResponseSchema)
      .errors({
        FORBIDDEN: { status: 403, data: z.object({ message: z.string() }) },
        NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
        CONFLICT: { status: 409, data: z.object({ message: z.string() }) },
      }),
    ensureSignalSeeds: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/applications/{applicationId}/ensure-signal-seeds',
        summary: 'Create missing Gold Vault booth signal seeds for tour play',
        inputStructure: 'detailed',
      })
      .input(BoothApplicationScopedMutationInputSchema)
      .output(BoothEnsureSignalSeedsResponseSchema)
      .errors({
        FORBIDDEN: { status: 403, data: z.object({ message: z.string() }) },
        NOT_FOUND: { status: 404, data: z.object({ message: z.string() }) },
        CONFLICT: { status: 409, data: z.object({ message: z.string() }) },
      }),
  });
